'use client';

import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

/**
 * SSR-safe "are we running on the client yet" flag.
 *
 * Returns `false` during server rendering and the first client render (so
 * hydration matches), then `true` on every render after hydration. Uses
 * `useSyncExternalStore` instead of `useState` + `useEffect` so it never calls
 * `setState` inside an effect (react-hooks/set-state-in-effect).
 */
export const useIsClient = (): boolean =>
  useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );
